import React, { useState } from "react";
import { Box, Typography, Divider, Paper } from "@mui/material";
import { IMAGE_URL } from "network";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { calculateOffAmount, convertDuration } from "utility";

const Preview = ({ formData }) => {
  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        position: "sticky",
        top: 20,
        height: "100%",
        maxHeight: "530px",
        overflowY: "scroll",
        scrollbarWidth: "none",
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{
          position: "sticky",
          top: 0, // adjust if you have a navbar
          backgroundColor: "#fff", // to avoid overlap with content
          textAlign: "center",
          zIndex: 10,
          py: 1, // padding for better spacing
        }}
      >
        Preview
      </Typography>

      <div className="position-relative">
        {/* Title */}
        <h5 className="text-limit mb-1">{formData.name}</h5>

        <h6 className="text-limit fw-normal mb-1 mt-0">{formData.sub_title}</h6>

        {formData.image && (
          <img
            crossOrigin="anonymous"
            src={IMAGE_URL + formData.image}
            alt={formData.title}
            className="rounded-circle round-img"
          />
        )}

        {formData?.type === "group" ? (
          <Box sx={{ mt: 1 }}>
            <div className="new-waxx">
              {formData?.addOns?.map((itme, i) => (
                <div className="wax-service p-3" key={i}>
                  <div className="row ">
                    <div className="col-10 px-1">
                      <h5>{itme.name}</h5>
                      <div className="serve-off d-flex gap-2 align-items-center">
                        <p>
                          ₹{" "}
                          {calculateOffAmount(
                            parseInt(itme?.servicePrice),
                            itme?.off_percentage
                          )}
                        </p>
                        <span>₹{parseInt(itme.servicePrice)}</span> |
                        <h6>
                          {itme.off_percentage ? itme.off_percentage : 0}% OFF
                        </h6>
                      </div>

                      <p style={{ fontSize: "11px" }}>
                        {convertDuration(itme.duration)}
                      </p>
                    </div>
                    <div className="col-2 px-1 text-center">
                      <img
                        crossOrigin="anonymous"
                        src={IMAGE_URL + itme.image}
                        width="40px"
                        height="40px"
                      />
                      <br />
                      {/* <button className="serve-add">Add </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Box>
        ) : (
          <>
            {/* Duration */}
            {formData.duration && (
              <h6 className="text-limit fw-normal mb-1 mt-0">
                {formData.duration} /min
              </h6>
            )}

            {/* Price and Discount */}
            {formData.servicePrice && (
              <Box
                sx={{
                  mt: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  ₹
                  {calculateOffAmount(
                    parseInt(formData.servicePrice),
                    formData.off_percentage
                  )}
                </Typography>
                {formData.productPrice > 0 && (
                  <Typography
                    variant="body2"
                    sx={{
                      textDecoration: "line-through",
                      color: "gray",
                    }}
                  >
                    ₹{parseInt(formData.servicePrice)}
                  </Typography>
                )}
                {formData.off_percentage > 0 && (
                  <Typography variant="body2" sx={{ color: "green" }}>
                    {formData.off_percentage}% off
                  </Typography>
                )}
              </Box>
            )}
          </>
        )}
      </div>

      {formData.overview?.length > 0 && (
        <>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" fontWeight="bold">
            Overview
          </Typography>

          <Box sx={{ mt: 1 }}>
            <Slider {...sliderSettings}>
              {formData.overview.map((proc, index) => (
                <Box key={index} sx={{ p: 1 }}>
                  {proc.image && (
                    <img
                      crossOrigin="anonymous"
                      src={IMAGE_URL + proc.image}
                      alt={proc.title}
                      style={{
                        width: "100%",
                        height: 120,
                        objectFit: "cover",
                        borderRadius: 6,
                      }}
                    />
                  )}
                </Box>
              ))}
            </Slider>
          </Box>
        </>
      )}

      <Box sx={{ mt: 1 }}>
        {formData?.dynamicData?.map((item, idx) => (
          <div className="precaution things p-3">
            <Typography variant="subtitle1" fontWeight="bold">
              {item.key}
            </Typography>
            <div className="thing-ul">
              <ul>
                {item.values?.map((val, i) => (
                  <li style={{ fontSize: "13px" }}>{val}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </Box>

      {/* Procedure Section */}
      {formData.procedures?.length > 0 && (
        <div className="things">
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" fontWeight="bold">
            Procedure
          </Typography>

          <Box sx={{ mt: 1 }}>
            <Slider {...sliderSettings}>
              {formData.procedures.map((proc, index) => (
                <Box key={index} sx={{ p: 1 }}>
                  {proc.image && (
                    <img
                      crossOrigin="anonymous"
                      src={IMAGE_URL + proc.image}
                      alt={proc.title}
                      style={{
                        width: "100%",
                        height: 120,
                        objectFit: "cover",
                        borderRadius: 6,
                      }}
                    />
                  )}
                  <Typography
                    variant="subtitle2"
                    align="center"
                    fontWeight="bold"
                    sx={{ mt: 1 }}
                  >
                    {proc.title}
                  </Typography>
                  <Typography
                    variant="caption"
                    align="center"
                    display="block"
                    sx={{ color: "text.secondary" }}
                  >
                    {proc.description}
                  </Typography>
                </Box>
              ))}
            </Slider>
          </Box>
        </div>
      )}

      {formData?.faq?.length > 0 && (
        <div className="new-waxx">
          <div className="wax-faq things p-3">
            <h3>Faqs</h3>
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              {formData.faq.map((item, i) => {
                const headingId = `flush-heading-${i}`;
                const collapseId = `flush-collapse-${i}`;
                return (
                  <div className="accordion-item" key={i}>
                    <h2 className="accordion-header" id={headingId}>
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${collapseId}`}
                        aria-expanded="false"
                        aria-controls={collapseId}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div
                      id={collapseId}
                      className="accordion-collapse collapse"
                      aria-labelledby={headingId}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">{item.answer}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </Paper>
  );
};

export default Preview;
